import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import type { Door } from "@/models";

type AlertRemoveDoorDialogProps = {
  open: boolean;
  data?: Door;
  onClose: () => void;
};

export function AlertRemoveDoorDialog({
  open: isOpen,
  data,
  onClose,
}: AlertRemoveDoorDialogProps) {
  if (!data) return <></>;

  const { name } = data;

  const title = `ไม่สามารถลบประตู ${name} ได้`;
  const content = `เนื่องจากประตู ${name} มีการกำหนดสิทธิ์การใช้งานอยู่`;

  return (
    <Dialog onClose={onClose} maxWidth="xs" open={isOpen}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{content}</Typography>
        <Typography variant="body1">
          กรุณาเปลี่ยนสิทธิ์การใช้งานเหล่านั้นให้ใช้ประตูอื่น ก่อนทำการลบ
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button color="primary" variant="contained" onClick={onClose}>
          ตกลง
        </Button>
      </DialogActions>
    </Dialog>
  );
}
